import { useRef, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './Partners.css';
import {
  ClientsLogo
} from './icons/ClientLogos';

const Partners = () => {
  const { t } = useLanguage();
  const scrollContainerRef = useRef(null);
  const [isScrolling, setIsScrolling] = useState(false);

  const partners = [
    { name: 'Dell Technologies', logo: <ClientsLogo src="/images/dell.webp" alt="Dell Technologies" size={80} /> },
    { name: 'Envoy', logo: <ClientsLogo src="/images/envoy.webp" alt="Envoy America" size={120} /> },
    { name: 'Cloudify', logo: <ClientsLogo src="/images/cloudify.webp" alt="Cloudify" size={120} /> },
    { name: 'EarlySense', logo: <ClientsLogo src="/images/earlysense.webp" alt="EarlySense" size={130} /> },
    { name: 'ItMyWay', logo: <ClientsLogo src="/images/itmyway.webp" alt="ItMyWay" size={130} /> },
    { name: 'GeoFree Software', logo: <ClientsLogo src="/images/geofreesoftware.webp" alt="GeoFree Software" size={130} /> },
    { name: 'Invention Land', logo: <ClientsLogo src="/images/inventionland.webp" alt="Invention Land" size={130} /> },
    { name: 'Cloudy Tech', logo: <ClientsLogo src="/images/cloudytech.webp" alt="Cloudy Tech" size={130} /> },
    { name: 'GoTo', logo: <ClientsLogo src="/images/goto.webp" alt="GoTo " size={130} /> },
    { name: 'Acumatica', logo: <ClientsLogo src="/images/acumatica.webp" alt="Acumatica" size={130} /> },
    { name: 'Innovo', logo: <ClientsLogo src="/images/innovo.webp" alt="Innovo" size={130} /> },
    { name: 'Eddie Bauer', logo: <ClientsLogo src="/images/eddiebauer.webp" alt="Eddie Bauer" size={130} /> },
    { name: 'Hamdan Center', logo: <ClientsLogo src="/images/hamdan.webp" alt="Hamdan" size={130} /> },
    { name: 'Logsios', logo: <ClientsLogo src="/images/logsios.webp" alt="Logsios" size={140} /> },
    { name: 'MoreTech', logo: <ClientsLogo src="/images/moretech.webp" alt="Moretech" size={140} /> },
  ];

  // Create multiple copies for infinite scroll
  const infinitePartners = [...partners, ...partners, ...partners];

  const scrollLeft = () => {
    if (scrollContainerRef.current && !isScrolling) {
      setIsScrolling(true);
      const scrollAmount = 600; // 3 cards * 200px each

      scrollContainerRef.current.scrollBy({
        left: -scrollAmount,
        behavior: 'smooth'
      });

      setTimeout(() => setIsScrolling(false), 600);
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current && !isScrolling) {
      setIsScrolling(true);
      const scrollAmount = 600; // 3 cards * 200px each

      scrollContainerRef.current.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });

      setTimeout(() => setIsScrolling(false), 600);
    }
  };

  return (
    <section id="partners-section" className="partners section">
      <div className="container">
        <h2 className="section-title">{t('partners.title')}</h2>
        <div className="partners-wrapper">
          <button
            className="nav-arrow nav-arrow-left"
            onClick={scrollLeft}
            aria-label="Scroll partners left"
            disabled={isScrolling}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>

          <div className="partners-scroll-container" ref={scrollContainerRef}>
            <div className="partners-scroll-track">
              {infinitePartners.map((partner, index) => (
                <div key={index} className="partner-card">
                  <div className="partner-logo">{partner.logo}</div>
                  <span className="partner-name">{partner.name}</span>
                </div>
              ))}
            </div>
          </div>

          <button
            className="nav-arrow nav-arrow-right"
            onClick={scrollRight}
            aria-label="Scroll partners right"
            disabled={isScrolling}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Partners;
